<div class="content-wrapper">
  <div class="page-heading">
    <h2> Major Amendments to the Rules </h2>
  </div>

  <div class="row g-3">
    <div *ngFor="let section of data; let i = index"
      class="col-lg-3 col-md-4 col-sm-6 col-12 dashboard-card card-popover " id="card-popover-{{ i }}"
      title="{{section.content | summury: 50}} v{{section.version}}" 
      data-bs-toggle="popover" 
      data-bs-trigger="manual"
      [attr.data-bs-offset]="[50,0]" 
      [attr.data-bs-html]="true" 
      [attr.data-bs-content]="getSubRules(section)"
      (click)="onCilck(section.id)" 
      (mouseover)="onHoverIn($event, section)"
    >
      <div class="dashboard-card-inner">
        <h4 class="dashboard-card-ttl">{{ section.title }}</h4>
        <p class="dashboard-card-des">{{ section.content  | summury : 100 }}</p>
        <span class='badge position-absolute bottom-0 end-0' data-toggle="tooltip" data-title="version 1.0">v{{section.version}}</span>
      </div>
    </div>
  </div>
  <div *ngIf="!data.length">
    <app-loader></app-loader>
  </div>
</div>

